import React from 'react';
import { IWizardItem } from '../WizardItem';
import styles from './WizardImage.module.scss';

interface Props {
	item: IWizardItem;
}

const WizardImage: React.FC<Props> = ({ item }) => {
	return (
		<img src={item.settings?.url} alt={item.title} className={styles.image} />
	);
};

export default WizardImage;
